import SiteNotificationsService from '../../services/SiteNotificationsService';


export const siteNotificationsViewerState = {
  namespaced: true,
  state: () => ({
    initialized: false,
    notifications: [],
  }),
  mutations: {
    setNotifications(state, notifications) {
      state.notifications = notifications;
    },
    setInitialized(state, initialized) {
      state.initialized = initialized;
    },
  },
  actions: {
    update: (context) =>{
      SiteNotificationsService.getUserShowedNotifications().then(result => {
        context.commit('setNotifications', result.data);
        context.commit('setInitialized', true);
      }).catch( err => {
        console.log(JSON.stringify(err));
        context.commit('setNotifications', []);
      });
    },

    init: (context) => {
      if (context.state.initialized){
        return;
      }
      context.dispatch('update');
    },
  },
  getters: {
    notifications: state => {
      return state.notifications;
    },
  },
};
